import React from 'react';

function renderInline(text: string, keyPrefix: string): React.ReactNode[] {
    return text
        .split(/(\*\*[^*]+\*\*)/g)
        .filter((part) => part !== '')
        .map((part, i) => {
            const match = part.match(/^\*\*([^*]+)\*\*$/);
            if (match) {
                return <strong key={`${keyPrefix}-${i}`}>{match[1]}</strong>;
            }
            return <React.Fragment key={`${keyPrefix}-${i}`}>{part}</React.Fragment>;
        });
}

// Minimal, dependency-free markdown rendering for LLM-generated blueprint
// text: bold spans and '- ' unordered lists only. Deliberately not a full
// markdown parser — no dangerouslySetInnerHTML, output is plain React
// elements built from the source string.
export function renderMarkdownLite(text: string): React.ReactNode {
    const lines = text.split('\n');
    const blocks: React.ReactNode[] = [];
    let listItems: string[] = [];
    let blockIndex = 0;

    const flushList = () => {
        if (listItems.length === 0) return;
        const items = listItems;
        blocks.push(
            <ul key={`list-${blockIndex++}`} className="list-disc pl-5">
                {items.map((item, i) => (
                    <li key={i}>{renderInline(item, `li-${blockIndex}-${i}`)}</li>
                ))}
            </ul>,
        );
        listItems = [];
    };

    lines.forEach((line) => {
        const listMatch = line.match(/^\s*-\s+(.*)$/);
        if (listMatch) {
            listItems.push(listMatch[1]);
            return;
        }
        flushList();
        if (line.trim() === '') {
            blocks.push(<br key={`br-${blockIndex++}`} />);
        } else {
            blocks.push(
                <p key={`p-${blockIndex++}`} className="mb-1 last:mb-0">
                    {renderInline(line, `p-${blockIndex}`)}
                </p>,
            );
        }
    });
    flushList();

    return blocks;
}
